import React from 'react';
import { Form, Select, Divider } from 'antd';
import ClinicAddressFields from './ClinicAddressFields';
import WorkingHoursManager from './WorkingHoursManager';
import { CLINIC_STATUS, CLINIC_STATUS_LABELS } from '../../utils/constants';

const { Option } = Select;

const ClinicForm = ({ form, disabled = false }) => {
  return (
    <>
      <ClinicAddressFields disabled={disabled} />

      <Divider />

      <Form.Item label="Status" name="status" rules={[{ required: true, message: 'Status is required' }]}>
        <Select placeholder="Select status" disabled={disabled}>
          {Object.values(CLINIC_STATUS).map((status) => (
            <Option key={status} value={status}>
              {CLINIC_STATUS_LABELS[status]}
            </Option>
          ))}
        </Select>
      </Form.Item>

      <Divider />

      <Form.Item name="working_hours" label="">
        <WorkingHoursManager disabled={disabled} />
      </Form.Item>
    </>
  );
};

export default ClinicForm;